import React from 'react';
import { Link } from 'react-router-dom';
import settings from "../constants/settings";
import {useTranslation} from "react-i18next";

const NotFound = () => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col justify-center items-center bg-white text-center p-8">
      <h1 className="text-7xl font-bold text-red-500 mb-4">404</h1>
      <p className="text-2xl text-gray-800 mb-6">{t('common.pageNotFound')}</p>
      <p className="text-gray-600 mb-6">{t('common.sorryPage')}</p>
      <Link
        to={settings.domain}
        className="px-6 py-3 hover:shadow-2xl text-white rounded bg-theme-color transition">
        {t('common.goBackHome')}
      </Link>
    </div>
  );
};

export default NotFound;
